import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-mobile-feed-page-template',
    templateUrl: './mobile-feed-page-template.component.html',
    styleUrls: ['./mobile-feed-page-template.component.scss'],
    standalone: false
})
export class MobileFeedPageTemplateComponent implements OnInit {
    @Input('loaded-pages') public loadedPages: number = 0;
    @Input('view-page') public viewPage: number = 0;
    @Input('count-of-pages') public countOfPages: number = 0;
    @Input('is-feed-empty') public isFeedEmpty = false;
    @Input('feed-empty-text') public feedEmptyText = 'Записей нет';
    @Input('no-more-content-text') public noMoreContentText: string =
        'Записей больше нет.';
    @Input('is-loading') public isLoading: Boolean = false;
    @Input('root-url') public url: string = '';
    @Input() public pages: Array<any> = [];
    @Input('height-offset') public offset = 0;
    @Output('load-next-page') public loadNextPage = new EventEmitter<any>();

    public constructor() {}
    public isFooterHidden: boolean = false;
    public ngOnInit(): void {
        if (this.url === 'home/history/list-upcoming') {
            this.isFooterHidden = true;
        }
    }

    public nextPage() {
        if (this.pages.length > this.viewPage) {
            this.viewPage++;
            this.scrollToPage(this.viewPage);
        } else {
            this.viewPage = this.pages.length;
            this.scrollToLoadMore();
        }
    }
    public prevPage() {
        if (this.viewPage !== 1) {
            this.viewPage--;
            this.scrollToPage(this.viewPage);
        }
    }

    public startLoading($event: any) {
        this.loadNextPage.emit(this.loadedPages);
        this.loadedPages++;
    }

    public scrollToPage(page: number) {
        this.scrollTo(`[id=page${page}]`);
    }

    public scrollToLoadMore() {
        this.scrollTo('[id="load-more"]');
    }

    public scrollTo(selector: string) {
        const pageElement = document.querySelector(selector);

        if (pageElement) {
            pageElement.scrollIntoView({ behavior: 'smooth' });
        }
    }
}
